import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Problems } from './components/Problems';
import { Treatments } from './components/Treatments';
import { WhyChooseUs } from './components/WhyChooseUs';
import { Results } from './components/Results';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { LocationMap } from './components/LocationMap';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-background text-foreground font-sans selection:bg-gold/30 selection:text-foreground" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <About data-id="element-4" />
        <Problems data-id="element-5" />
        <Treatments data-id="element-6" />
        <WhyChooseUs data-id="element-7" />
        <Results data-id="element-8" />
        <Testimonials data-id="element-9" />
        <FAQ data-id="element-10" />
        <FinalCTA data-id="element-11" />
        <LocationMap data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}